import Vue from 'vue';

import { apiPath } from '../constants';

export default Vue.resource(
  `${apiPath}/adbazaar/payment{/action}{/itemId}{/subAction}/`,
  {},
  {
    getPaymentURL: {
      method: 'POST',
      params: { action: 'start-payment' },
    },
    downloadInvoiceFactor: {
      params: {
        action: 'invoices',
        subAction: 'download',
      },
      responseType: 'blob',
    },
    downloadTransactionInvoiceFactor: {
      params: {
        action: 'invoices',
        subAction: 'download',
      },
      responseType: 'blob',
    },
  },
);
